import fetch from '../../../utils/fetch';
import {
    QUESTION_SET_BOOKMARK,
    QUESTION_SET_GAUGE_LEVEL,
    QUESTION_SET_IS_ACTION,
    QUESTION_SET_IS_FANTASY,
    QUESTION_SET_NEXT,
    QUESTION_SET_SELECTED_ANSWER,
    QUESTION_SHOW_RESET,
    QUESTION_SHOW_SUCCESS,
} from './mutation-types';
import {CURRENT_QUESTION, CURRENT_QUESTION_BY_PACK, QUESTION, UPDATE_BOOKMARK} from '../../../constants/api-routes';
import {HYDRA_ID} from '../../../constants/hydra';

const getDefaultState = () => {
    return {
        zeroPool: false,
        item: null,
        selectedAnswer: null,
        isFantasy: false,
        isAction: false,
        gaugeLevel: 1,
        next: null,
        bookmark: false,
    }
};
const state = getDefaultState();

function success(item) {
    return {type: QUESTION_SHOW_SUCCESS, item};
}

function reset() {
    return {type: QUESTION_SHOW_RESET};
}

function selectedAnswer(answerOption) {
    return {type: QUESTION_SET_SELECTED_ANSWER, answerOption};
}

function setIsAction() {
    return {type: QUESTION_SET_IS_ACTION};
}

function setIsFantasy() {
    return {type: QUESTION_SET_IS_FANTASY};
}

function setGaugeLevel(gaugeLevel) {
    return {type: QUESTION_SET_GAUGE_LEVEL, gaugeLevel};
}

function setNext() {
    return {type: QUESTION_SET_NEXT};
}

function setBookmark(bookmark) {
    return {type: QUESTION_SET_BOOKMARK, bookmark}
}

const getters = {
    zeroPool: state => state.zeroPool,
    item: state => state.item,
    selectedAnswer: state => state.selectedAnswer,
    isFantasy: state => state.isFantasy,
    isAction: state => state.isAction,
    gaugeLevel: state => state.gaugeLevel,
    next: state => state.next,
    detectChange: state => {
        const currentUserAnswer = (state.item || {}).currentUserAnswer || {};
        const selectedAnswer = ((currentUserAnswer || {}).answer || {})[HYDRA_ID];
        return !(
            currentUserAnswer.gaugeLevel === state.gaugeLevel &&
            currentUserAnswer.isFantasy === state.isFantasy &&
            currentUserAnswer.isAction === state.isAction &&
            selectedAnswer == state.selectedAnswer
        );
    },
    bookmark: state => state.bookmark,
};

const actions = {
    retrieve({commit}, {id = null, packId = null}) {
        let url = id ? QUESTION + id : CURRENT_QUESTION;
        if (packId !== null) {
            url = CURRENT_QUESTION_BY_PACK + packId;
        }
        return fetch(url, {})
            .then(data => {
                commit(reset());
                commit(success(data));
                commit(setNext());
            }).catch(e => {
                return Promise.reject(e);
            });
    },
    reset({commit}) {
        commit(reset());
    },
    updateBookmark({commit, state}, {bookmark}) {
        const action = UPDATE_BOOKMARK + state.item.currentUserAnswer['id'];
        return fetch(action, {method: 'PUT', data: {bookmark: bookmark}})
            .then(() => {
                commit(setBookmark(bookmark));
            })
    },
    submitAnswer({commit, state}) {
        const postValues = {
            isFantasy: state.isFantasy,
            isAction: state.isAction,
            gaugeLevel: state.gaugeLevel,
            answer: state.selectedAnswer,
            question: state.item[HYDRA_ID],
        };

        const action = state.item.currentUserAnswer[HYDRA_ID];
        return fetch(action, {method: 'PUT', data: postValues})
            .then(() => {
                commit(setNext());
            })
            .catch(e => Promise.reject(e));
    },
};

const mutations = {
    [QUESTION_SHOW_SUCCESS](state, payload) {
        state.item = payload.item;
        const currentUserAnswer = state.item.currentUserAnswer;
        if (currentUserAnswer) {
            if (currentUserAnswer.answer) {
                state.selectedAnswer = currentUserAnswer.answer[HYDRA_ID];
            }
            state.isFantasy = currentUserAnswer.isFantasy;
            state.isAction = currentUserAnswer.isAction;
            state.gaugeLevel = currentUserAnswer.gaugeLevel;
            state.bookmark = currentUserAnswer.bookmark;
        }
    },
    [QUESTION_SHOW_RESET](state) {
        Object.assign(state, getDefaultState());
    },
    [QUESTION_SET_SELECTED_ANSWER](state, answerOption) {
        if (state.selectedAnswer !== answerOption[HYDRA_ID]) {
            state.selectedAnswer = answerOption[HYDRA_ID];
            state.isAction = false;
            state.isFantasy = false;
            if (answerOption.weight === 0) {
                state.gaugeLevel = 0
            }
        } else {
            state.selectedAnswer = null;
        }
    },
    [QUESTION_SET_IS_ACTION](state) {
        state.isAction = !state.isAction;
        state.selectedAnswer = null;
        state.isFantasy = false;
    },
    [QUESTION_SET_IS_FANTASY](state) {
        state.isFantasy = !state.isFantasy;
        state.selectedAnswer = null;
        state.isAction = false;
    },
    [QUESTION_SET_GAUGE_LEVEL](state, gaugeLevel) {
        state.gaugeLevel = gaugeLevel;
        if (gaugeLevel < 0) {
            return;
        }
        let answer = state.item.answers ? state.item.answers.find(
            answer => answer[HYDRA_ID] === state.selectedAnswer,
        ) : null;
        if (answer && answer.weight === 0) {
            state.selectedAnswer = null;
        }
    },
    [QUESTION_SET_NEXT](state) {
        let answer = state.item.answers ? state.item.answers.find(
            answer => answer[HYDRA_ID] === state.selectedAnswer,
        ) : null;
        state.next = state.item.nextQuestionId[
            answer ? answer.weight : ''
            ];
    },
    [QUESTION_SET_BOOKMARK](state, payload) {
        state.bookmark = payload.bookmark;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/question/show.js